import { Plugin } from '@ckeditor/ckeditor5-core';
import EditHelpButton from '../theme/icons/help.svg';
import { ButtonView } from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import '../theme/css/style.css';

export default class EditHelp extends Plugin {
	init() {
		const editor = this.editor;

		editor.ui.componentFactory.add('editHelp', (locale) => {
			const view = new ButtonView(locale);
			
			view.set({
				label: 'Roc Editor Help',
				icon: EditHelpButton,
				tooltip: true,
			});
			view.on('execute', () => {
				const editHelpConfig = editor.config.get('edithelp');
				editHelpConfig.callback();
			});
			return view;
		});
	}
}
